import { render, staticRenderFns } from "./classReview.vue?vue&type=template&id=bc236796&scoped=true"
import script from "./classReview.vue?vue&type=script&lang=js"
export * from "./classReview.vue?vue&type=script&lang=js"
import style0 from "./classReview.vue?vue&type=style&index=0&id=bc236796&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc236796",
  null
  
)

export default component.exports